import { BaseService } from './BaseService'
const ACHIEVEMENTS_PATH = '/my-achievements'
const POINT_CODE_PATH = '/point-code'
const ACHIEVEMENTS_DONATE_AWARD_PATH = '/donate-award'
class AchievementsService extends BaseService {
  getAchievementsList () {
    return this.get(ACHIEVEMENTS_PATH)
  }

  getAchievementsFilterList (getParams) {
    return this.get(ACHIEVEMENTS_PATH + getParams)
  }

  setSelectedDonateAwardId (formData) {
    return this.post(ACHIEVEMENTS_DONATE_AWARD_PATH, formData)
  }

  sendPointCode (formData) {
    return this.post(POINT_CODE_PATH, formData)
  }
}
export default new AchievementsService()
